import React, { useState, useEffect, useRef } from 'react';
import {
  Input,
  DatePicker,
  Divider,
  InputNumber,
  Switch,
  Select,
  Tooltip,
  Row,
  Col,
} from 'antd';

let autoComplete;

const loadScript = (url, callback) => {
  const script = document.createElement('script');
  script.type = 'text/javascript';
  script.async = true;

  if (script.readyState) {
    script.onreadystatechange = function () {
      if (script.readyState === 'loaded' || script.readyState === 'complete') {
        script.onreadystatechange = null;
        callback();
      }
    };
  } else {
    script.onload = () => callback();
  }

  script.src = url;
  document.getElementsByTagName('head')[0].appendChild(script);
};

async function handlePlaceSelect(updateQuery, setMapsAddress) {
  const addressObject = autoComplete.getPlace();
  const query = addressObject.name;
  updateQuery(query);
  setMapsAddress({
    address: addressObject.formatted_address,
    name: addressObject.name,
    object: addressObject,
  });
}

function handleScriptLoad(updateQuery, setMapsAddress, autoCompleteRef) {
  autoComplete = new window.google.maps.places.Autocomplete(
    autoCompleteRef.current,
    { componentRestrictions: { country: 'es' } },
  );
  autoComplete.setFields(['name', 'address_components', 'formatted_address']);
  autoComplete.addListener('place_changed', () =>
    handlePlaceSelect(updateQuery, setMapsAddress),
  );
}

const SearchLocationInput = ({ setMapsAddress }) => {
  const [query, setQuery] = useState('');
  const autoCompleteRef = useRef(null);

  useEffect(() => {
    loadScript(
      'https://maps.googleapis.com/maps/api/js?key=AIzaSyA_Xl-80Wr8poLCWPLaTsnfXH8F4nfX9ss&libraries=places&callback=Function.prototype',
      () => handleScriptLoad(setQuery, setMapsAddress, autoCompleteRef),
    );
  }, []);

  return (
    <input
      className="width100"
      ref={autoCompleteRef}
      onChange={event => setQuery(event.target.value)}
      placeholder="Donde queda la pista?"
      value={query}
    />
  );
};

export default SearchLocationInput;
